import { render, staticRenderFns } from "./AccountWishlist.vue?vue&type=template&id=1ab5466b&"
import script from "./AccountWishlist.vue?vue&type=script&lang=js&"
export * from "./AccountWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports